import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Flex,
  Text,
  Input,
  Button,
  SimpleGrid,
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  TableContainer,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  Thead,
} from "@chakra-ui/react";
import Card from "components/Card/Card";
import apiUrl from "variables/api";

import {toast} from "react-toastify";

export default function ADR() {
  const [search, setSearch] = useState("");
  const [founded, setFounded] = useState("");
  const [data, setData] = useState([]);
  const [newSubstance, setNewSubstance] = useState({
    number: "",
    name: "",
    color: "",
    toxicity: "",
    neutralize: "",
  });
  const {
    isOpen: isPreviewOpen,
    onOpen: onPreviewOpen,
    onClose: onPreviewClose,
  } = useDisclosure();
  const {
    isOpen: isAddOpen,
    onOpen: onAddOpen,
    onClose: onAddClose,
  } = useDisclosure();

  const roles = localStorage.getItem("roles");

  useEffect(() => {
    axios
      .get(apiUrl + "/data/adr", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        if (response.data.length !== 0) {
          setData(response.data);
          console.log(response.data);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas pobierania danych z API");
      });
  }, [newSubstance]);

    const handleRemove = async (index) => {
        console.log(data[index].id);
        await axios
        .delete(apiUrl + "/data/adr/" + data[index].id, {
            headers: { "x-access-token": localStorage.getItem("token") },
        }).then((response) => {
            console.log(response);
            const newData = data.filter((item, i) => i !== index);
            setData(newData);
            toast.success("Substancja została usunięta pomyślnie!");
        }).catch((error) => {
            console.error(error);
            toast.error("Napotkano błąd podczas usuwania substancji");
        })
       
    };

  const handleSearch = () => {
    if (!data) return;
    const found = data.find(
      (e) =>
        e.number === search ||
        e.name.toLowerCase() === search.toLowerCase() ||
        e.name.toLowerCase().includes(search.toLowerCase())
    );
    if (!found) {
      toast.error("Nie znaleziono substancji o podanej nazwie lub numerze");
      return;
    }
    const toxicity = ["Nietoksyczna", "Lekko toksyczna", "Toksyczna", "Bardzo toksyczna"];
    found.toxicity = toxicity[parseInt(found.toxicity) - 1];
    setFounded(found);
  };

  const handleAddSubstance = () => {
    axios
      .post(apiUrl + "/data/adr", newSubstance, {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
          console.log(response);
        setData([...data, response.data]);
        toast.success("Substancja została dodana pomyślnie!");
        setNewSubstance({
          number: "",
          name: "",
          color: "",
          toxicity: "",
          neutralize: "",
        });
        onAddClose();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Napotkano błąd podczas dodawania substancji");
      });
  };

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }}>
      <Card minH="125px">
        <Flex direction="column" gap={2}>
          <SimpleGrid columns={{ sm: 1, md: 1, xl: 2 }}>
            <TableContainer>
            <Table size="sm">
                <Thead>
                  <Tr>
                    <Th isNumeric>Cyfra</Th>
                    <Th>Znaczenie jako pierwsza</Th>
                    <Th>Znaczenie jako druga/trzecia</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr>
                    <Td isNumeric>1</Td>
                    <Td>-</Td>
                    <Td>wybuchowość</Td>
                  </Tr>
                  <Tr>
                    <Td isNumeric>2</Td>
                    <Td>gaz</Td>
                    <Td>zdolność wytwarzania gazu</Td>
                  </Tr>
                  <Tr>
                    <Td isNumeric>3</Td>
                    <Td>materiał ciekły zapalny</Td>
                    <Td>łatwozapalność</Td>
                  </Tr>
                  <Tr>
                    <Td isNumeric>4</Td>
                    <Td>materiał stały zapalny</Td>
                    <Td>-</Td>
                  </Tr>
                  <Tr>
                    <Td isNumeric>5</Td>
                    <Td>
                      materiał utleniający, podtrzymujący palenie lub nadtlenek
                      organiczny
                    </Td>
                    <Td>właściwości utleniające</Td>
                  </Tr>
                  <Tr>
                    <Td isNumeric>6</Td>
                    <Td>materiał trujący</Td>
                    <Td>toksyczność</Td>
                  </Tr>
                  <Tr>
                    <Td isNumeric>7</Td>
                    <Td>-</Td>
                    <Td>promieniotwórczość</Td>
                  </Tr>
                  <Tr>
                    <Td isNumeric>8</Td>
                    <Td>materiał żrący</Td>
                    <Td>działanie żrące</Td>
                  </Tr>
                  <Tr>
                    <Td isNumeric>9</Td>
                    <Td>zagrożenie dla środowiska</Td>
                    <Td>zagrożenie samorzutną i gwałtowną reakcją</Td>
                  </Tr>
                  <Tr>
                    <Td isNumeric>0</Td>
                    <Td>-</Td>
                    <Td>brak dodatkowego zagrożenia</Td>
                  </Tr>
                  <Tr>
                    <Td isNumeric>X</Td>
                    <Td>całkowity zakaz kontaktu danego materiału z wodą</Td>
                    <Td>-</Td>
                  </Tr>
                </Tbody>
              </Table>
            </TableContainer>
            <Flex direction="column" gap={2} alignItems="center">
              <Text fontSize="xl" fontWeight="bold">
                Wyszukiwarka substancji:
              </Text>
              <Flex gap={2}>
                <Input
                  placeholder="Wyszukaj substancję"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <Button onClick={handleSearch}>Szukaj</Button>
              </Flex>
              {founded && (
                <Flex direction="column" gap={2}>
                  <Text>Numer rozpoznawczy: {founded.number}</Text>
                  <Text>Nazwa substancji: {founded.name}</Text>
                  <Text>Barwa: {founded.color}</Text>
                  <Text>Toksyczność: {founded.toxicity}</Text>
                  <Text>Sposób neutralizacji: {founded.neutralize}</Text>
                </Flex>
              )}
            </Flex>
          </SimpleGrid>
          {(roles.includes("950812557147529217") || roles.includes("1190995987154616381")) && (
          <Button onClick={onPreviewOpen}>Pokaż Substancje</Button>
          )}
        </Flex>
      </Card>

      {/* Modal Podglądu */}
      <Modal isOpen={isPreviewOpen} onClose={onPreviewClose} size="7xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Lista Substancji</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <TableContainer>
              <Table variant="stripped">
                <Thead>
                    <Tr>
                        <Th>Numer</Th>
                        <Th>Nazwa</Th>
                        <Th>Barwa</Th>
                        <Th>Toksyczność</Th>
                        <Th>Neutralizacja</Th>
                        <Th></Th>
                    </Tr>
                </Thead>
                <Tbody>
                  {data.map((item, index) => (
                    <Tr key={index}>
                      <Td>{item.number}</Td>
                      <Td>{item.name}</Td>
                        <Td>{item.color}</Td>
                        <Td>{item.toxicity}</Td>
                        <Td>{item.neutralize}</Td>
                      <Td>
                        <Button onClick={() => handleRemove(index)}>Usuń</Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>
          <ModalFooter>
            <Text>
                1 - Nietoksyczna
                2 - Lekko toksyczna
                3 - Toksyczna
                4 - Bardzo toksyczna
            </Text>
            <Button onClick={onAddOpen} ml={3}>Dodaj Substancję</Button>
            <Button onClick={onPreviewClose} ml={3}>
              Zamknij
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal Dodawania */}
      <Modal isOpen={isAddOpen} onClose={onAddClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Dodaj nową substancję</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex direction="column" gap={2}>
                <Text fontSize="sm" fontWeight="bold">
                    Numer rozpoznawczy:
                </Text>
              <Input
                placeholder="Numer"
                value={newSubstance.number}
                onChange={(e) =>
                  setNewSubstance({ ...newSubstance, number: e.target.value })
                }
              />
                <Text fontSize="sm" fontWeight="bold">
                    Nazwa substancji:
                </Text>
              <Input
                placeholder="Nazwa"
                value={newSubstance.name}
                onChange={(e) =>
                  setNewSubstance({ ...newSubstance, name: e.target.value })
                }
              />
                <Text fontSize="sm" fontWeight="bold">
                    Barwa:
                </Text>
              <Input
                placeholder="Barwa"
                value={newSubstance.color}
                onChange={(e) =>
                  setNewSubstance({ ...newSubstance, color: e.target.value })
                }
              />
                <Text fontSize="sm" fontWeight="bold">
                    Toksyczność:
                </Text>
                <Text fontSize={"sm"}>
                    1 - Nietoksyczna
                    2 - Lekko toksyczna
                    3 - Toksyczna
                    4 - Bardzo toksyczna
                </Text>
              <Input
                placeholder="Toksyczność"
                value={newSubstance.toxicity}
                type="number"
                onChange={(e) =>
                  setNewSubstance({ ...newSubstance, toxicity: e.target.value })
                }
              />
                <Text fontSize="sm" fontWeight="bold">
                    Sposób neutralizacji:
                </Text>
              <Input
                placeholder="Sposób neutralizacji"
                value={newSubstance.neutralize}
                onChange={(e) =>
                  setNewSubstance({
                    ...newSubstance,
                    neutralize: e.target.value,
                  })
                }
              />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button onClick={handleAddSubstance}>Dodaj</Button>
            <Button onClick={onAddClose} ml={3}>
              Anuluj
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}
